'use strict';

angular.module('app')
  .service('DiveOperator', function ($http, $location, $rootScope, $timeout, $routeParams, $q, $injector, utils, Wishlist, Request, config) {
    var DiveOperator = {},
      _this = this,
      spCounter = 1,
      DOpromise = false;

    DiveOperator.search = function (location, shopSlug, value) {
      return Request.get('shop/' + location + '/' + shopSlug + '/', value).then(function (req) {
        return req.data;
      }, function (err) {
        return err;
      });
    };

    DiveOperator.itineraries = function (scope) {
      return Request.get('shop/' + $routeParams.slug + '/itineraries/', {
        kind: utils.shopKind('Liveaboard'),
      }).then(function (res) {
        var pins = [];

        _.each(res.data.results, function (val) {
          val.itinerary = _.clone(val);

          if (val.harbourArrivalPoint && val.harbourArrivalPoint.length == 2) {
            pins.push({
              lat: val.harbourArrivalPoint[1],
              lng: val.harbourArrivalPoint[0],
              icon: config.mapIcons ? config.mapIcons.withPrice : '',
              info: {
                title: val.harbourArrivalTitle,
              },
              getMessageScope: function () {
                return scope;
              },
              message: '<div ng-include src=\'"templates/_harbour-popup.html"\'></div>',
            });
          }
          if (val.harbourDeparturePoint && val.harbourDeparturePoint.length == 2) {
            pins.push({
              lat: val.harbourDeparturePoint[1],
              lng: val.harbourDeparturePoint[0],
              icon: config.mapIcons ? config.mapIcons.withPrice : '',
              info: {
                title: val.harbourDepartureTitle,
              },
              getMessageScope: function () {
                return scope;
              },
              message: '<div ng-include src=\'"templates/_harbour-popup.html"\'></div>',
            });
          }

          // if (val.portDepartureLat !== val.portArrivalLat
          //     && val.portDepartureLng !== val.portArrivalLng) {
          //     pins.push({
          //       lat: val.portArrivalLat,
          //       lng: val.portArrivalLng,
          //       icon: config.mapIcons.withoutPrice,
          //       info: {
          //         title: val.portArrival
          //       },
          //       getMessageScope: function () { return scope; },
          //       message: '<div ng-include src=\'"templates/_small_infowindow.html"\'></div>'
          //     });
          // }
        });

        pins = _.uniq(pins, 'info.title');


        return {
          pins: pins,
          itineraries: res.data.results,
        };
      });
    };

    DiveOperator.reviews = function (operatorType, newPageLink, slug) {
      var link = 'shop/' + (slug || $routeParams.slug) + '/reviews/',
        query = {
          kind: operatorType,
          page_size: 3,
        };
      if (newPageLink) {
        link = newPageLink;
        query = {};
      }
      return Request.get(link, query, newPageLink).then(function (rating) {
        return rating.data;
      });
    };

    DiveOperator.getParams = function (data) {
      var result = {};
      if (data.kind === utils.shopKind('Dive resort') || data.kind === utils.shopKind('Dive center')) {
        _.each(data.parameters, function (val) {
          if (val.title === 'Agencies') {
            result.agencies = '';
            _.each(val.parameters, function (v) {
              result.agencies += v + ',';
            });
            result.agencies = result.agencies.slice(0, -1);
          }
        });
      }

      return result;
    };

    DiveOperator.getResorts = function (scope, shop) {
      return Request.get('places/dive-sites/shop/' + $routeParams.slug + '/').then(function (res) {
        var pins = [],
          shopPin = [];

        _.each(res.data, function (val) {
          pins.push({
            lat: val.point[1],
            lng: val.point[0],
            icon: config.mapIcons.diveSites,
            info: {
              title: val.title,
              url: '/dive-site/' + val.areaSlug + '/' + val.slug,
            },
            getMessageScope: function () {
              return scope;
            },
            message: '<div ng-include src=\'"templates/_small_infowindow.html"\'></div>',
          });
        });

        if (shop && shop.point) {
          shopPin.push({
            lat: shop.point[1],
            lng: shop.point[0],
            icon: config.mapIcons.withPrice,
            info: {
              title: shop.title,
            },
            focus: true,
            getMessageScope: function () {
              return scope;
            },
            message: '<div ng-include src=\'"templates/_small_infowindow.html"\'></div>',
          });
        }

        return {
          pins: pins,
          shopPin: shopPin,
        };
      });
    };

    DiveOperator.topDiveSites = function () {
      return Request.get('places/dive-sites/shop/' + $routeParams.slug + '/top-5/').then(function (res) {
        return res.data;
      });
    };

    DiveOperator.getPhotos = function (kind) {
      return Request.get('images/photos/' + $routeParams.slug + '/', {
        photo_kind: kind,
        page_size: 50,
      }).then(function (res) {
        return res.data.results;
      });
    };

    DiveOperator.getRoomsPhotos = function () {
      return Request.get('images/rooms/' + $routeParams.slug + '/', {
        page_size: 50,
      }).then(function (res) {
        return res.data.results;
      });
    };

    DiveOperator.getLayoutPhotos = function () {
      return Request.get('images/layout/' + $routeParams.slug + '/', {
        page_size: 50,
      }).then(function (res) {
        return res.data.results;
      });
    };

    DiveOperator.getUnderwhaterPhotos = function () {
      return Request.get('images/underwater/' + $routeParams.slug + '/', {
        page_size: 50,
      }).then(function (res) {
        return res.data.results;
      });
    };

    DiveOperator.liveaboardPhotos = function () {
      var q = $q.defer(),
        _this = this,
        requests = [
          _this.getPhotos([10]),
          _this.getRoomsPhotos(),
          _this.getLayoutPhotos(),
          _this.getUnderwhaterPhotos()
        ],
        allPhotos = [];

      return $q.all(requests).then(function (data) {
        _.each(data, function (val) {
          if (val.length) {
            _.each(val, function (elem) {
              allPhotos.push(elem);
            });
          }
        });
        return {
          allPhotos: allPhotos,
          groupedPhotos: {
            photos: data[0],
            cabins: data[1],
            layout: data[2],
            underwater: data[3],
          },
        };
      });
    };

    DiveOperator.diveResortPhotos = function () {
      var q = $q.defer(),
        _this = this,
        requests = [
          _this.getPhotos([0, 20, 50, 60]),
          _this.getRoomsPhotos(),
          _this.getUnderwhaterPhotos()
        ],
        allPhotos = [],
        resortPhotos = [],
        centerPhotos = [];

      return $q.all(requests).then(function (data) {
        _.each(data, function (val) {
          if (val.length) {
            _.each(val, function (elem) {
              allPhotos.push(elem);
            });
          }
        });

        if (data[0].length) {
          resortPhotos = _(data[0]).filter(function (val) {
            return val.shopPhotoKind !== 0;
          }).sortBy('shopPhotoKind').reverse().value();
          centerPhotos = _.filter(data[0], function (val) {
            return val.shopPhotoKind === 0;
          });
        }

        return {
          allPhotos: allPhotos,
          groupedPhotos: {
            photos: resortPhotos,
            diveCenter: centerPhotos,
            cabins: data[1],
            underwater: data[2],
          },
        };
      });
    };


    DiveOperator.getResortAvailability = function (filter) {
      return Request.get('booking/resort/' + $routeParams.slug + '/rooms/availability/', filter).then(function (res) {
        return res.data;
      });
    };

    DiveOperator.diveCenterPhotos = function () {
      var q = $q.defer(),
        _this = this,
        requests = [
          _this.getPhotos([0, 20, 40]),
          _this.getUnderwhaterPhotos()
        ],
        allPhotos = [];

      return $q.all(requests).then(function (data) {
        _.each(data, function (val) {
          if (val.length) {
            _.each(val, function (elem) {
              allPhotos.push(elem);
            });
          }
        });
        return {
          allPhotos: allPhotos,
          groupedPhotos: {
            photos: data[0],
            underwater: data[1],
          },
        };
      });
    };

    DiveOperator.getDeals = function (data) {
      return Request.get('shop/' + $routeParams.slug + '/deals/', data).then(function (res) {
        return res.data;
      });
    };

    DiveOperator.addReview = function (review, timeout) {
      review.shopSlug = review.shopSlug ? review.shopSlug : $routeParams.slug;

      var data = _.clone(review),
        GTM = $injector.get('GTM');

      if (data.trip_end_date) {
        data.trip_end_date = data.trip_end_date + 'T22:00:00';
      }

      GTM.event('reviews_write_new_completed');

      return Request.post('shop/' + data.shopSlug + '/reviews/', data).then(function (res) {
        if (timeout) {
          $timeout(function () {
            $rootScope.showNotify('Your review was successfully added');
          }, 4500);
        } else {
          $rootScope.showNotify('Your review was successfully added');
        }

        return res.data;
      });
    };

    DiveOperator.addReviewWithImg = function (review, timeout) {
      var Auth = $injector.get('Auth'),
        GTM = $injector.get('GTM'),

        data = _.clone(review);
      data.trip_end_date = data.to;
      data.shop_slug = data.place.slug;

      GTM.event('reviews_write_new_completed');

      return Request.post('shop/' + data.shop_slug + '/reviews/', data).then(function (res) {
        // SUCCESS EVENT
        if (timeout) {
          $timeout(function () {
            $rootScope.showNotify('Your review was successfully added');
          }, 4500);
        } else {
          $rootScope.showNotify('Your review was successfully added');
        }

        return res.data;
      });
    };

    DiveOperator.getShopPromotion = function () {
      return Request.get('shop/' + $routeParams.slug + '/promotions/').then(function (res) {
        return res.data;
      });
    };


    DiveOperator.getProducts = function (date, kind) {
      return Request.get('shop/' + $routeParams.slug + '/products/', {
        kinds: date.kind || null,
        from: date.startDate || null,
        to: date.endDate || null,
        is_available: date.month === 'Show available' ? true : null,
      }).then(function (res) {
        _.each(res.data, function (val) {
          if (_.find(val.tags, {
            title: 'Sale',
          })) {
            val.isSale = true;
          }
        });

        return res.data;
      });
    };

    DiveOperator.getTrips = function (date, filter, url, revert) {
      var localCounter = spCounter;

      if (!filter) {
        filter = {page: 1};
      }

      if (url) {
        var newUrl = url.split('page=')[1];
        filter.page = newUrl.split('&')[0];
      }

      console.log(filter);

      angular.extend(filter, {pageSize: 4});

      if (DOpromise) { DOpromise.resolve(false); }

      DOpromise = $q.defer();


      Request.get('shop/' + $routeParams.slug + '/trips/', {
        departure_date: date.startDate && !revert ? date.startDate : null,
        departure_date_less_then: date.startDate && revert ? date.startDate : null,
        is_available: date.month === 'Show available' ? true : null,
        itinerary: date.itinerary || filter.itinerary || null,
        promotion: date.promotion || filter.promotion || null,
        is_promotion: filter.is_promotion || null,
        price: filter.price || null,
        duration: filter.duration || null,
        number_of_products: date.numberOfProducts || null,
        page: filter.page || null,
        page_size: date.month === 'Show all' ? 1000 : (filter.pageSize || null),
      }, false, DOpromise).then(function (res) {
        if (spCounter - 1 === localCounter) {
          _.each(res.data.results, function (val) {
            if (_.find(val.tags, {
              title: 'Sale',
            })) {
              val.isSale = true;
            }

            if (val.promotion && val.promotion.dateTo) {
              val.promotionEndIn = moment(val.promotion.dateTo).utc().diff(moment(), 'd');

              if (val.promotionEndIn < 0) {
                val.promotionEndIn = null;
              }
            }
          });

          res.data.revert = revert;

          if (revert) {
            res.data.results.reverse();
          }

          DOpromise.resolve({trips: res.data.results, all: res.data});
        } else {
          DOpromise.reject('old data');
        }
      });

      spCounter += 1;

      return DOpromise.promise;
    };

    DiveOperator.getCabins = function (tripID) {
      return Request.get('shop/trips/' + tripID + '/').then(function (res) {
        _.each(res.data, function (val) {
          if (_.find(val.tags, {
            title: 'Sale',
          })) {
            val.isSale = true;
          }

          _.each(val.packages, function (v) {
            v.roomCategory.bedType = utils.selectBeds(v.roomCategory.bedType);
          });
        });
        return res.data[0];
      });
    };


    DiveOperator.getRooms = function (date) {
      return Request.get('shop/' + $routeParams.slug + '/rooms/', {
        from: date.startDate || null,
        to: date.endDate || null,
      })
        .then(function (res) {
          _.each(res.data, function (val) {
            if (_.find(val.tags, {
              title: 'Sale',
            })) {
              val.isSale = true;
            }
            val.bedType = utils.selectBeds(val.bedType);
          });
          return res.data;
        });
    };

    DiveOperator.getSleepPackages = function (date) {
      return Request.get('shop/' + $routeParams.slug + '/sleep-and-dives/', {
        from: date.startDate || null,
        to: date.endDate || null,
      }).then(function (res) {
        _.each(res.data, function (val) {
          if (_.find(val.tags, {
            title: 'Sale',
          })) {
            val.isSale = true;
          }
        });

        return res.data;
      });
    };


    DiveOperator.getOtherDiveoperators = function () {
      return Request.get('shop/' + $routeParams.slug + '/other-operators/')
        .then(function (res) {
          return res.data;
        });
    };

    DiveOperator.getHarbours = function (scope) {
      return Request.get('search/harbours/', {
        shop: $routeParams.slug,
      }).then(function (res) {
        var markers = [];
        _.each(res.data, function (val) {
          if (val.portDepartureLat && val.portDepartureLng) {
            markers.push({
              lat: val.portDepartureLat,
              lng: val.portDepartureLng,
              icon: config.mapIcons.withoutPrice,
              info: {
                shop: val.shop,
                title: val.portDeparture,
                slug: val.slug,
                type: 'harbour',
              },
              getMessageScope: function () {
                return scope;
              },
              message: '<div ng-include src=\'"templates/_small_infowindow.html"\'></div>',
            });
          }
        });
        return markers;
      });
    };

    DiveOperator.bookingEnquire = function (data) {
      return Request.post('shop/booking_enquire/', data);
    };

    DiveOperator.bindAgencies = function (data) {
      var agencies = '';
      _.each(data, function (val) {
        if (val.group === 190) {
          _.each(val.parameters, function (v) {
            if (v == 'PADI' || v == 'SSI') {
              agencies += v + ',';
            }
          });
        }
      });
      return agencies.slice(0, -1);
    };

    DiveOperator.getItinerary = function (slug) {
      return Request.get('shop/itineraries/' + slug + '/').then(function (res) {
        return res.data;
      });
    };

    DiveOperator.getSeasons = function (slug) {
      return Request.get('shop/' + $routeParams.slug + '/seasons/').then(function (res) {
        return res.data;
      });
    };

    DiveOperator.getHighlights = function ($scope) {
      return Request.get('places/highlights/shop/' + $routeParams.slug + '/').then(function (res) {
        var markers = [],
          highlights = [];

        _.each(res.data, function (val) {
          if (val.point && val.point.length === 2) {
            markers.push({
              lat: val.point[1],
              lng: val.point[0],
              icon: config.mapIcons.yellow,
              info: val,
              getMessageScope: function () {
                return $scope;
              },
              message: '<div ng-include src=\'"templates/_highlight_window.html"\'></div>',
              compileMessage: true,
              autoPan: false,
            });

            highlights.push({
              kind: val.kind,
              title: val.title,
              point: val.point,
              id: val.id,
              description: val.description,
              thumbnails: val.thumbnails,
            });
          }
        });

        return {
          pins: markers,
          data: highlights,
        };
      });
    };


    DiveOperator.askQuestion = function (form) {
      return Request.post('shop/' + form.shopSlug + '/ask-question/', form).then(function (res) {
        $rootScope.showNotify('Your question has been successfully submitted');

        return res.data;
      });
    };


    DiveOperator.getPromotions = function (data, filters, type) {
      angular.extend(data, filters);
      var url = 'promotions/';

      if (type === 'dr_deals') {
        url += 'resorts/';
      }

      return Request.get(url, data).then(function (res) {
        // res.data.maxPages = Math.ceil(res.data.count / res.data.results.length);
        _.each(res.data.results, function (val) {
          console.log(val);
          if (_.find(val.promotions, {isMain: true})) {
            val.promotions = _.sortBy(val.promotions, 'isMain').reverse();
          } else {
            _.remove(val.promotions, function (v) {
              return !v.priceData;
            });

            val.promotions = _.sortBy(val.promotions, 'value').reverse();
          }
        });

        return res.data;
      });
    };

    DiveOperator.getVideos = function () {
      return Request.get('images/photos/' + $routeParams.slug + '/', {
        photo_kind: 70,
        page_size: 10,
      }).then(function (res) {
        return res.data.results;
      });
    };

    DiveOperator.triggerWishlist = function (type, vm) {
      if (!$rootScope.user) {
        $rootScope.wishlist = $routeParams.slug;
        return;
      }

      var data = {
        item_type: 'Shop',
        item_slug: $routeParams.slug,
      };

      if (type == 'delete') {
        data = vm.info.isWishlist;
      }

      Wishlist[type](data).then(function (data) {
        if (type == 'delete') {
          vm.info.isWishlist = false;
        } else {
          vm.info.isWishlist = data.item.id;
        }
      });
    };

    DiveOperator.triggerWishlistOperators = function (e, result) {
      e.stopPropagation();
      e.preventDefault();

      if (!$rootScope.user) {
        $rootScope.wishlist = $routeParams.slug;
        return;
      }

      var type = 'Shop';

      if (result.hasOwnProperty('diveSiteType')) {
        type = 'DiveSite';
      }
      var data = {
        item_type: type,
        item_slug: result.slug,
      };
      type = 'add';

      if (result.isWishlist) {
        data = result.isWishlist;
        type = 'delete';
      }

      Wishlist[type](data).then(function (data) {
        if (result.isWishlist) {
          result.isWishlist = false;
        }

        if (type == 'add') {
          result.isWishlist = data.item.id;
        }
      });
    };

    DiveOperator.getScubaTribeReviews = function () {
      return Request.get('shop/' + $routeParams.slug + '/scuba-tribe/reviews', {page_size: 5}).then(function (res) {
        return res.data;
      });
    };

    DiveOperator.submitReview = function (form, vm) {
      form.$submitted = true;

      if (form.$valid) {
        if ($rootScope.user) {
          DiveOperator.addReview(vm.addReview).then(function (res) {
            form.$submitted = false;
            if (vm.reviews.data.results) {
              vm.reviews.data.results.unshift(res.data);
            } else {
              vm.reviews.data.results = res.data;
            }
            vm.info.rating = res.averageVotes.rate;
            vm.reviews.numberOfReviews++;
            vm.reviews.averageVotes = res.averageVotes;
            vm.reviews.reviewsPosted = true;

            jQuery.fancybox.close();

            vm.addReview = {};

            $location.search('showRatingPopup', null);
          }).catch(function () {
            form.$submitted = false;
            $rootScope.showNotify('Something went wrong! Please try again later.');
          });
        } else {
          $rootScope.review = _.clone(vm.addReview);
          $rootScope.review.shopSlug = $routeParams.slug;
          $location.path('/login/');
          jQuery.fancybox.close();

          $location.search('showRatingPopup', null);
        }
      }
    };

    return DiveOperator;
  });
